import EditNoteModal from "legacy/manage/dashboard/EditNoteModal"
import PropTypes from "prop-types"
import React from "react"

class Note extends React.Component {
  render() {
    return (
      <div className="note">
        <div className="date-range">
          {this.props.shortDateText}
          <EditNoteModal
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            text={this.props.text}
            noteRoute={this.props.noteRoute}
          />
        </div>
        <div
          className="note-text break-words"
          dangerouslySetInnerHTML={{ __html: this.props.markdownText }}
        />
      </div>
    )
  }
}

Note.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  markdownText: PropTypes.string.isRequired,
  shortDateText: PropTypes.string.isRequired,
  noteRoute: PropTypes.string.isRequired,
}

export default Note
